import { createAction } from '@reduxjs/toolkit';
export const setConditionalVariablesAction = createAction('@@TEMPLATES/_/conditionalVariables');
